module.exports = __webpack_public_path__ + "img/Safety1.191bbc26.svg";